import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const SAPendingCourses = () => {
    const [courses, setCourses] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/studyabroad/pending');
            const data = await response.json();
            setCourses(data);
        } catch (error) {
            
            console.error('Error fetching courses:', error);
        }
    };

    const handleDelete = async (courseId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this study abroad course?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/studyabroad/delete/${courseId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setCourses(courses.filter(course => course.id !== courseId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The study abroad course has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete course');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the study abroad course.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting course:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the study abroad course.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handleApprove = async (courseId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this study abroad course?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/studyabroad/approve/${courseId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setCourses(courses.filter(course => course.id !== courseId));
                        Swal.fire({
                            title: "Approved!",
                            text: "The study abroad course has been approved.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to approve course');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to approve the study abroad course.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error approving course:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to approve the study abroad course.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter courses based on search term
    const filteredCourses = courses.filter(course => 
        (course.country && course.country.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (course.university && course.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (course.courseName && course.courseName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (course.level && course.level.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (course.duration && course.duration.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (
        <div>
            <AdminDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>PENDING STUDY ABROAD COURSES</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>
                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                                <tr>
                                    <th>Country</th>
                                    <th>University / Institute</th>
                                    <th>Course / Degree Name</th>
                                    <th>Level</th>
                                    <th>Duration</th>
                                    <th>Start Date</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCourses.map((course) => (
                                    <tr key={course.id}>
                                        <td>{course.country}</td>
                                        <td>{course.university}</td>
                                        <td>{course.courseName}</td>
                                        <td>{course.level}</td>
                                        <td>{course.duration}</td>
                                        <td>{new Date(course.startDate).toLocaleDateString('en-CA')}</td>
                                        <td><a href="#!" id='view-website'>WEBSITE</a></td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='app-details' onClick={() => handleApprove(course.id)}>APPROVE</a>
                                            <a href="#!" id='del-details' onClick={() => handleDelete(course.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SAPendingCourses;
